import React, { useState, useRef, useEffect, Fragment } from "react";
import { Card, CardBody, Table, Row, Col } from "reactstrap";
import ProfileCustomQuestionForm from "./Form";
import ProfileCustomQuestionHit from "./Hit";
import Notifications from "../commons/Notifications";

const ProfileCustomQuestionsIndex = ({ profileCustomQuestions }) => {
  const [questions, setQuestions] = useState([]);
  const notifications = useRef(null);

  useEffect(() => {
    setQuestions(profileCustomQuestions || []);
  }, [profileCustomQuestions]);

  const showNotification = (title, message, type) => {
    notifications.current.addNotifications(title, message, type);
  };

  const addQuestion = question => setQuestions([...questions, question]);
  const removeQuestion = id => setQuestions(questions.filter(q => q.id !== id));
  const updateHit = q => setQuestions(questions.map(x => (x.id === q.id ? q : x)));

  return (
    <Fragment>
      <Notifications ref={notifications} />
      <Card className="mb-4 material-shadow">
        <CardBody className="bg-light">
          <Row className="d-flex align-items-center">
            <Col md="8">
              <h3 className="h4 mb-0">Preguntas Adicionales de Perfil</h3>
              <p className="small text-muted mb-sm-0">
                Listado de preguntas dinámicas que se mostrarán al usuario al editar su perfil.
              </p>
            </Col>
            <Col md="4" className="text-right">
              <ProfileCustomQuestionForm
                bgColor="success"
                buttonText="Nueva Pregunta"
                showNotification={showNotification}
                addQuestion={addQuestion}
                size="md"
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="material-shadow">
        <CardBody>
          <Table>
            <thead>
            <tr>
              <th>#</th>
              <th>Pregunta</th>
              <th>Tipo</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
            </thead>
            <tbody>
            {questions.map((question, i) => (
              <ProfileCustomQuestionHit
                key={question.id}
                index={i + 1}
                question={question}
                showNotification={showNotification}
                removeQuestion={removeQuestion}
                updateHit={updateHit}
              />
            ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default ProfileCustomQuestionsIndex;